import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/global.css';
import 'jquery';
import 'popper.js';
import 'bootstrap';
import i18n from './i18n';
import Notifications from 'vue-notification';
import device from 'vue-device-detector';
import ActivityTrackerMixin from '@/mixins/ActivityTrackerMixin.vue';
import VueGtag from 'vue-gtag';
import config from '../config.js';

Vue.config.productionTip = true;
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});
Vue.use(Notifications); // Notifications
Vue.use(device); // Device detection
Vue.mixin(ActivityTrackerMixin); // User activity tracking

// Initialize GA4 tracking with vue-gtag
if (config.GA4_MEASUREMENT_ID) {
    Vue.use(VueGtag, {
        config: {
            id: config.GA4_MEASUREMENT_ID
        }
    }, router);
}

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
}).$mount('#app');
